<template>
  <div
    class="label"
    :class="[
      { 'label--icon': icon },
      { 'label--success': colored && success },
      { 'label--warning': colored && warning },
      { 'label--error': colored && error }
    ]"
  >
    <v-icon v-if="icon">{{ iconText }}</v-icon>
    {{ number | formatNumber }}
  </div>
</template>

<script>
export default {
  name: 'Label',
  props: {
    value: {
      type: Number,
      default: 0
    },
    colored: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    warning: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    number () {
      return this.value ? String(this.value).padStart(2, '0') : this.value
    },

    iconText () {
      if (this.success) return 'check_circle'
      if (this.warning) return 'error'
      if (this.error) return 'cancel'
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  align-items: center;
  background-color: $gray-4;
  border-radius: 20px;
  color: $gray-8;
  display: inline-flex;
  font-family: var(--title-font);
  font-size: 18px;
  font-weight: 800;
  height: 32px;
  padding: 0 10px 0;
  justify-content: center;

  &.label--icon {
    padding: 0 10px 0 5px;
  }

  .v-icon {
    color: var(--white);
    margin-right: 6px;
  }

  &.label--success {
    background-color: var(--success);
    color: var(--white);
  }

  &.label--warning {
    background-color: var(--warning);
  }

  &.label--error {
    background-color: var(--error);
    color: var(--white);
  }
}
</style>
